import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import {
  isSessionExpired,
  getRolSession,
  routerRedirect,
  getTenantDomain,
} from "../api/global";

routerRedirect();

const routes = [
  {
    path: "/",
    redirect: !isSessionExpired()
      ? getRolSession() === "ADMIN"
        ? "/admin"
        : "/client-area"
      : "/login",
    name: "Home",
    component: import(/* webpackChunkName: "about" */ "../views/User/Login.vue"),
  },
  {
    path: "/login",
    redirect: !isSessionExpired()
      ? getRolSession() === "ADMIN"
        ? "/admin"
        : "/client-area"
      : "",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/User/Login.vue"),
  },
  {
    path: "/login/admin",
    name: "LoginAdmin",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Admin/LoginUrl.vue"),
  },
  {
    path: "/auth/:code",
    name: "AdminAuth",
    props: true,
    component: () => import("../views/Admin/Login.vue"),
  },
  {
    path: "/recovery",
    name: "Recovery",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/User/Recovery.vue"),
  },
  {
    path: "/register",
    redirect: getTenantDomain() ? "" : "/",
    name: "Register",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/User/Register.vue"),
  },
  {
    path: "/debt",
    redirect: isSessionExpired() ? "/" : "",
    name: "Debt",
    component: () => import("../views/Debt/NewDebt.vue"),
  },
  {
    path: "/debt/:id",
    redirect: isSessionExpired() ? "/" : "",
    name: "DebtDetail",
    props: true,
    component: () => import("../views/Debt/DetailDebt.vue"),
  },
  {
    path: "/client-area",
    redirect: isSessionExpired() ? "/" : "",
    name: "clientArea",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Client/ClientArea.vue"),
  },
  {
    path: "/client-area/profile",
    redirect: isSessionExpired() ? "/" : "",
    name: "clientProfile",
    component: () => import("../views/Client/ClientProfile.vue"),
  },
  {
    path: "/client-area/complete-profile",
    redirect: isSessionExpired() ? "/" : "",
    name: "completeProfile",
    props: true,
    component: () => import("../views/Client/CompleteProfile.vue"),
  },
  {
    path: "/client-area/new-subscription/:type?",
    redirect: isSessionExpired() ? "/" : "",
    name: "newContract",
    props: true,
    component: () => import("../views/Client/Contract.vue"),
  },
  {
    path: "/client-area/SEPA",
    redirect: isSessionExpired() ? "/" : "",
    name: "SEPA",
    component: () => import("../views/Client/SEPA.vue"),
  },
  {
    path: "/client-area/payment/:returnmac",
    redirect: isSessionExpired() ? "/" : "",
    name: "payment",
    props: true,
    component: () => import("../views/Client/SEPA.vue"),
  },
  {
    path: "/sign/:code/:event?",
    name: "signContract",
    props: true,
    component: () => import("../views/Client/ViewContract.vue"),
  },
  {
    path: "/view-contract/:code",
    name: "viewContract",
    props: true,
    component: () => import("../views/Client/ViewContract.vue"),
  },
  {
    path: "/services",
    name: "service",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Service/Service.vue"),
  },
  {
    path: "/admin",
    redirect: isSessionExpired() ? "/" : "",
    name: "Admin",
    component: () => import("../views/Admin/Tenants.vue"),
  },
  {
    path: "/admin/clients/:id",
    redirect: isSessionExpired() ? "/" : "",
    name: "AdminClients",
    props: true,
    component: () => import("../views/Admin/Clients.vue"),
  },
  {
    path: "/admin/PYME/:id",
    redirect: isSessionExpired() ? "/" : "",
    name: "AdminPymeDetail",
    props: true,
    component: () => import("../views/Admin/Cases.vue"),
  },
  {
    path: "/legal-information",
    name: "legalInformation",
    component: () => import("../views/LegalInformation.vue"),
  },
  {
    path: "/privacy-policy",
    name: "privacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue"),
  },
  {
    path: "/cookies-policy",
    name: "cookiesPolicy",
    component: () => import("../views/CookiesPolicy.vue"),
  },
  {
    path: "/conditions",
    name: "conditions",
    component: () => import("../views/Conditions.vue"),
  }, {
    path: '/404',
    name: 'notFound',
    component: () => import("../views/NotFound.vue"),
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: () => import("../views/Maintenance.vue"),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'notFound' }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isMaintenanceMode = process.env.VUE_APP_MAINTENANCE_MODE === "true"; 
 
  if (isMaintenanceMode && to.name !== "Maintenance") {
    next({ name: "Maintenance" });
  } else {
    next();
  }
});

export default router;
